import { render } from "./PrescriberDetailsModal.vue?vue&type=template&id=336245c4"
import script from "./PrescriberDetailsModal.vue?vue&type=script&lang=js"
export * from "./PrescriberDetailsModal.vue?vue&type=script&lang=js"

import "./PrescriberDetailsModal.vue?vue&type=style&index=0&id=336245c4&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__